module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "33",
      "width": "100"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "33",
      "width": "100"
    }
  }, [(_vm.isVerifying) ? _c('mu-card', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.labelVerifyingAccount')) + "\n          "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('mu-circular-progress', {
    attrs: {
      "size": 60
    }
  })], 1)])], 1) : _vm._e(), _vm._v(" "), (!_vm.isVerifying) ? _c('mu-card', [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.labelAccountActivated')) + "\n        ")]), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "secondary": "",
      "label": _vm.$t('message.labelContinueText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToDashboard()
      }
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "33",
      "tablet": "33",
      "width": "100"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-172f1447","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/EmailVerification/EmailVerification.vue
// module id = 3613
// module chunks = 1